import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { InstantSearch } from 'react-instantsearch';
import { useLocation } from 'react-router-dom';
import { taskSearch } from '@/utils/typesense/clients/taskSearch';
import WorkspaceContextProvider from '@/context/WorkspaceContext';

const ObjectViewLayout = ({ tabView, aboutCard, children }) => {
	const { pathname } = useLocation();
	const isAttachmentsTab = pathname.endsWith('/attachments');
	const [showCard, setShowCard] = useState(!isAttachmentsTab);
	const [drawerVisible, setDrawerVisible] = useState(!isAttachmentsTab);

	useEffect(() => {
		if (isAttachmentsTab) {
			setDrawerVisible(false);
			const timer = setTimeout(() => setShowCard(false), 350);
			return () => clearTimeout(timer);
		}

		setShowCard(true);
		setDrawerVisible(false);
		const drawerTimer = setTimeout(() => setDrawerVisible(true), 450);
		return () => clearTimeout(drawerTimer);
	}, [isAttachmentsTab]);

	return (
		<div style={{ position: 'relative' }}>
			<InstantSearch indexName='tasks' searchClient={taskSearch}>
				<Grid container>
					<Grid
						size={{ xs: 12, sm: isAttachmentsTab ? 12 : 9 }}
						sx={{
							transition: 'all 350ms cubic-bezier(0.4, 0, 0.2, 1)',
						}}
					>
						<WorkspaceContextProvider>{tabView}</WorkspaceContextProvider>
					</Grid>
					<Grid
						size={{ xs: drawerVisible ? 4 : 0, sm: drawerVisible ? 3 : 0 }}
						sx={{
							position: 'sticky',
							top: 0,
							alignSelf: 'flex-start',
							transform: drawerVisible ? 'translateX(0)' : 'translateX(120%)',
							opacity: drawerVisible ? 1 : 0,
							pointerEvents: drawerVisible ? 'auto' : 'none',
							transition:
								'transform 350ms cubic-bezier(0.4, 0, 0.2, 1), opacity 250ms ease',
							overflow: 'hidden',
						}}
					>
						{showCard && aboutCard}
					</Grid>
				</Grid>
				{children}
			</InstantSearch>
		</div>
	);
};

ObjectViewLayout.displayName = 'ObjectViewLayout';

export default ObjectViewLayout;
